// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"28f1164d","256":"04f032d5","453":"88e15787","462":"912ca033","563":"e352ad46","980":"c8d523ec"}[chunkId] + ".chunk.js";
};